import FeedFormTriger from "components/files/feed-form/FeedFormTriger";
import FeedPostModal from "components/files/modals/FeedPostModal";
import FeedLayout from "layouts/files/FeedLayout";
import { useState } from "react";
import { EngajmentModal, FeedPost, Repost, ThreadPost } from "components";
import FeedPost2 from "components/files/feed/FeedPost2";
import FeedPost3 from "components/files/feed/FeedPost3";
import FeedPost4 from "components/files/feed/FeedPost4";
import FeedPost5 from "components/files/feed/FeedPost5";
import FeedPostFixedTriggerer from "ui/files/feed-form/FeedPostFixedTriggerer";
import { UserPopover } from "ui";
import FeedPost6 from "components/files/feed/FeedPost6";
import FeedPost7 from "components/files/feed/FeedPost7";
import FeedIncident from "components/files/feed/FeedIncident";
import FeedPost8 from "components/files/feed/FeedPost8";
import FeedPost9 from "components/files/feed/FeedPost9";
import FeedPostVid1 from "ui/files/test/FeedPostVid1";
import FeedPostVid3 from "ui/files/test/FeedPostVid3";
import FeedPostVid2 from "ui/files/test/FeedPostVid2";

const Feed = () => {
    const [openPostsModal, setOpenPostsModal] = useState(false);
    const [openEngagmentModal, setOpenEngagmentModal] = useState(false);

    return (
        <FeedLayout pageTitle="home">
            <FeedFormTriger openModal={setOpenPostsModal} modalType="post" />

            <UserPopover />
            <FeedPost5 />
            <FeedPostVid3 />
            <FeedPost2 />
            <FeedPost9 />
            <FeedPostVid2 />
            <Repost />
            <FeedPostVid2 />
            <FeedIncident />
            <FeedPostVid3 />
            <FeedPost8 />
            <FeedPostVid1 />
            <ThreadPost />
            <FeedPostVid3 />
            <FeedPost6 />
            <FeedPost7 />
            <FeedPost />
            <FeedPost3 />
            <FeedPost4 />
            <FeedPost />
            {/* <LightBox /> */}
            <FeedPostModal
                open={openPostsModal}
                setOpen={setOpenPostsModal}
                setOpenEngajment={setOpenEngagmentModal}
            />
            <EngajmentModal
                open={openEngagmentModal}
                setOpen={setOpenEngagmentModal}
            />
            <FeedPostFixedTriggerer setOpenPostsModal={setOpenPostsModal} />
        </FeedLayout>
    );
};

export default Feed;
